import React, { useState } from 'react';

import { useTranslate } from '../translate';

interface ChatFooterProps {
  inputRef: React.RefObject<HTMLSpanElement | null>;
  placeholder: string;
  sendPrompt: (text: string) => void;
  isLoading: boolean;
}

export function ChatFooter({
  inputRef,
  placeholder,
  sendPrompt,
  isLoading,
}: ChatFooterProps) {
  const translate = useTranslate();
  const [isBlank, setIsBlank] = useState(true);
  const canSend = !isLoading && !isBlank;

  return (
    <div className="jr-ai-assist-modal-footer">
      <div className="form-ai-group" onClick={focusInputUnlessButton}>
        <span
          contentEditable="plaintext-only"
          role="textbox"
          ref={inputRef}
          className="textarea"
          style={
            {
              '--placeholder-text': `"${placeholder}"`,
            } as React.CSSProperties
          }
          onInput={updateIsBlank}
          onKeyDown={sendOnEnter}
        />

        <div className="form-group-actions" style={{ justifyContent: 'end' }}>
          <div className="subgroup">
            <button
              className="jr-ai-assist-button primary"
              type="button"
              onClick={submit}
              disabled={!canSend}
            >
              <i
                className="jr-ai-icon jr-ai-icon-arrow-up"
                title={translate('sendNow')}
              />
            </button>
          </div>
        </div>
      </div>

      <p className="jr-ai-assist-disclaimer">{translate('disclaimer')}</p>
    </div>
  );

  function sendOnEnter(event: React.KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (canSend) submit();
    }
  }

  function submit() {
    const input = inputRef.current;
    if (!input) return;

    const text = input.innerText;
    input.innerText = '';
    setIsBlank(true);
    sendPrompt(text);
  }

  function updateIsBlank() {
    setIsBlank(!inputRef.current?.innerText.trim());
  }

  function focusInputUnlessButton(event: React.MouseEvent) {
    if ((event.target as HTMLElement).closest('button')) return;
    inputRef.current?.focus();
  }
}
